module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isCommercialOverrideModalVisible) ? _c('commercial-address-override', {
    on: {
      "confirm": _vm.confirmCommercialOverride,
      "cancel": _vm.cancelCommercialOverride
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), (_vm.isMergePartialUserModalVisible) ? _c('merge-partial-user', {
    attrs: {
      "closeAction": _vm.closeMergePartialUserModal,
      "partialUserId": _vm.user.id
    },
    on: {
      "userMergeRequested": _vm.handleUserMerge
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INVESTOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InvestorOption",
      "id": "InvestorOption",
      "value": "INVESTOR",
      "disabled": _vm.isFinancialAdvisorOrAdmin()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INVESTOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INVESTOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InvestorOption"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.FINANCIAL_ADVISOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "FinancialAdvisorOption",
      "id": "FinancialAdvisorOption",
      "disabled": "",
      "value": "ADVISOR"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADVISOR")
    },
    on: {
      "click": function($event) {
        _vm.selectAdvisor()
      },
      "__c": function($event) {
        _vm.user.userType = "ADVISOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FinancialAdvisorOption"
    }
  }, [_vm._v("Financial Advisor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.MINOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "MinorOption",
      "id": "MinorOption",
      "value": "MINOR",
      "disabled": _vm.isFinancialAdvisorAdminOrInstitutional()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "MINOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "MINOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "MinorOption"
    }
  }, [_vm._v("Minor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.ADMIN)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "AdminOption",
      "id": "AdminOption",
      "disabled": "",
      "value": "ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADMIN")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "ADMIN"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "AdminOption"
    }
  }, [_vm._v("Admin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INSTITUTIONAL_REPRESENTATIVE)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InstitutionalRepresentativeOption",
      "id": "InstitutionalRepresentativeOption",
      "value": "INSTITUTIONAL_REPRESENTATIVE"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INSTITUTIONAL_REPRESENTATIVE")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INSTITUTIONAL_REPRESENTATIVE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InstitutionalRepresentativeOption"
    }
  }, [_vm._v("Institutional Representative")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.READ_ONLY)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "ReadOnlyOption",
      "id": "ReadOnlyOption",
      "value": "READ_ONLY"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "READ_ONLY")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "READ_ONLY"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ReadOnlyOption"
    }
  }, [_vm._v("Read-only")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.userCommentCategories,
      "showToggleAll": false,
      "placeholder": "Select relevant categories",
      "optionLabel": "name"
    },
    model: {
      value: (_vm.userCommentCategory),
      callback: function($$v) {
        _vm.userCommentCategory = $$v
      },
      expression: "userCommentCategory"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below.")]), _vm._v(" "), (_vm.savingComment) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saving-color"
  }, [_vm._v("[ Saving... ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaved) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saved-color"
  }, [_vm._v("[ Saved ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaveError) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-error-color"
  }, [_vm._v("[ Not Saved ]")]) : _vm._e(), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "limit": 255,
      "input": _vm.userCommentInput,
      "id": "comment",
      "required": false,
      "showNotice": false,
      "showLimit": true,
      "textColorClass": 'vinous-text',
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), _c('basic-information', {
    ref: "basicInformation",
    attrs: {
      "looseValidation": true,
      "basicInformation": _vm.user,
      "enableMfa": _vm.enableMfa
    },
    on: {
      "emailUpdated": _vm.handleEmailChange
    }
  }), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": !_vm.emailIsValid
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Provide investor log in\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Enable MFA\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showLoginNotice) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.user.residentialAddress && _vm.user.mailingAddress) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Residential Address',
      "residentialAddress": _vm.user.residentialAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.user.mailingAddress,
      "is-admin": true,
      "selected-user-type": _vm.user.userType,
      "shouldShowAllowPOBoxInput": true,
      "userHasBeenAllowedPOBox": _vm.userHasBeenAllowedPOBox
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've changed the default account",
      "subtitle": "",
      "closeAction": _vm.hideDefaultAccountAlert,
      "isShowing": _vm.showDefaultAccountChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Accounts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No accounts found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length > 0) ? _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--sm cols-5': _vm.user.accounts.length > 3 || _vm.fetchingSummaryReports
    }
  }, [(_vm.fetchingSummaryReports) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.fetchingSummaryReports) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.user.accounts), function(account) {
    return _c('tr', {
      key: account.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatAmount(account.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': account.id !== _vm.user.defaultAccountId
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": account.id,
        "for": account.id
      },
      domProps: {
        "value": account.id
      },
      on: {
        "click": function($event) {
          _vm.changeDefaultAccount(account)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "lbl-defaultAccount",
      attrs: {
        "for": account.id
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center last-column-data"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(account)
        }
      }
    }, [_vm._v("View details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.generateSummaryReport(account)
        }
      }
    }, [_vm._v("Summary Report")])])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg btn-new",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openAccountCreationModal()
      }
    }
  }, [_vm._v("Create new")]), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length === 0 && _vm.user.userType !== _vm.userTypes.INSTITUTIONAL_REPRESENTATIVE.name && _vm.user.userType !== _vm.userTypes.READ_ONLY.name) ? _c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mergePartialUser()
      }
    }
  }, [_vm._v("Merge partial user")]) : _vm._e()])]), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator top-margin"
  }) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Recent activity\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "bottom-margin"
  }, [(!_vm.user.lastLogins || _vm.user.lastLogins.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                No login activity found.\n              ")])]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.user.lastLogins), function(login) {
    return _c('tr', {
      key: login.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatLoginTimestamp(login.loggedInAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(login.device || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(login.ipAddress || '—'))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator top-margin"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Investor feedback\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [(_vm.fetchingFeedback) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.fetchingFeedback && _vm.userFeedback.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                No feedback submitted.\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.fetchingFeedback && _vm.userFeedback.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.userFeedback), function(feedback) {
    return _c('tr', {
      key: feedback.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatFeedbackDate(feedback.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatFeedbackScore(feedback.score)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center feedback-comments"
    }, [_vm._v(_vm._s(feedback.reason || '—'))])])
  }))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Comment Category")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n              Normally we do NOT provide minors with a log in.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type of account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default Account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center last-column-title"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last login")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Device")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("IP address")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Score")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comments")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d03fd344","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserDetail.vue
// module id = 2204
// module chunks = 1